<div class="modal">
    <ng-container *ngIf="!selectionVideo; else videoSelected">
        <div class="header">
            <h1>{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_ADD_IMAGE_VIDEO' | translate}}</h1>
        </div>
        <div class="body">
            <div class="section media-selection-section">
                <div class="section-row">
                    <div class="section-column">
                        <input type="file" class="image-input" (change)="addBackgroundImageToCustomization($event.target.files); this.value=null;">
                        <div class="icon-smash_image icon"></div>
                        <span class="subtitle" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_IMAGE</span>
                    </div>
                    <div class="section-column" (click)="displaySelectionVideo($event)">
                        <div class="icon-smash_videos icon"></div>
                        <span class="subtitle" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_VIDEO</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #videoSelected>
        <div class="header">
            <h1>{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_ADD_VIDEO' | translate}}</h1>
        </div>
        <div class="body">
            <div class="description">
                <span class="text" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_COPY_VIDEO_LINK</span>
            </div>
            <div class="section">
                <div class="form-section">
                    <div class="form-input">
                        <app-smash-input type="text" borderStyle="full"
                            placeholder="{{'PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_INPUT_VIDEO_URL_PLACEHOLDER' | translate}}" [(ngModel)]="url"
                            [error]='error'>
                        </app-smash-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <button class="btn-new white" type="submit" (click)="hideSelectionVideo($event)"
                translate>PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_CANCEL</button>
            <button class="btn-new red" (click)="addBackgroundVideo(url)" translate>PREMIUM_CUSTOMIZATION_MODAL_RECEIVER_BUTTON_LABEL_SAVE</button>
        </div>
    </ng-template>
</div>